export const SectionCardDemo2 = () => {
  return (
    <section
      id='1801fa4e-2184-4bf7-b8e3-f5fafc28f0fd'
      data-el='1801fa4e-2184-4bf7-b8e3-f5fafc28f0fd'
      className='mk-comp mk-comp-section relative'
      data-component-type='section'
      style={{
        width: 'calc(100% + 0px)',
        alignSelf: 'center',
        // margin: '50px 0px',
        padding: '0px 8px',
        color: 'rgba(0, 0, 0, 0.98)',
        borderRadius: 'var(--radius-md)',
        zIndex: 0,
        maxWidth: '100%',
        minHeight: '100%',
        height: 'auto',
        overflow: 'hidden',
        gap: '0px',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <div
        className='absolute inset-0'
        style={{
          overflow: 'hidden',
          borderRadius: 'inherit',
          zIndex: -1,
          borderTop: '0px solid var(--color-primary-70)',
          borderInlineEnd: '0px solid var(--color-primary-70)',
          borderBottom: '0px solid var(--color-primary-70)',
          borderInlineStart: '0px solid var(--color-primary-70)',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: -1,
            backgroundColor: 'rgb(0, 0, 0)',
            opacity: 0,
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: -2,
            color: 'currentcolor',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: -3,
            objectFit: 'cover',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: -4,
            backgroundImage: 'url("undefined")',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            backgroundAttachment: 'scroll',
            transition: 'transform 0.1s ease-out',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: -5,
            background:
              'radial-gradient(circle at top,transparent 14%, var(--color-neutral-20) 15% ,var(--color-neutral-20) 19% , transparent 20%) 0% 0% / 96px 96px, radial-gradient(circle at bottom,transparent 14%, var(--color-neutral-20) 15% ,var(--color-neutral-20) 19% , transparent 20%) 0% 0% / 96px 96px, radial-gradient(circle at right,transparent 14%, var(--color-neutral-20) 15% ,var(--color-neutral-20) 19% , transparent 20%) 0% 0% / 96px 96px, radial-gradient(circle at left,transparent 14%, var(--color-neutral-20) 15% ,var(--color-neutral-20) 19% , transparent 20%) 0% 0% / 96px 96px',
            opacity: 0.45,
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: -6,
            background: 'var(--color-primary-20)',
          }}
        />
      </div>
      <div
        className='mk-comp relative inset-0 overflow-hidden rounded-lg'
        id='fd8ba66d-1175-4f17-9ec3-79880120dbbf'
        data-el='fd8ba66d-1175-4f17-9ec3-79880120dbbf'
        style={{
          borderWidth: 0,
          backgroundColor: 'var(--color-neutral-70)',
          borderColor: 'var(--color-primary-80)',
          aspectRatio: '3 / 2',
          width: 'min(100%, 100% - 20px)',
          alignSelf: 'unset',
          margin: '20px 10px',
          padding: 0,
        }}
      >
        <img
          src='https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animals/owl1.jpg'
          alt=''
          className='w-full h-full object-cover rounded-lg'
        />
        <div className='absolute top-2 left-2 right-2 z-10 flex items-center justify-between max-w-full overflow-hidden gap-2' />
      </div>
      <div
        className='mk-comp border border-solid rounded-md text-base break-words text-start text-on-primary-20 t94x3a7'
        id='a02cd7c9-df80-4480-8202-6a3a1093f85a'
        data-el='a02cd7c9-df80-4480-8202-6a3a1093f85a'
        style={{
          width: 'calc(100% + 0px)',
          alignSelf: 'unset',
          margin: 0,
          padding: '20px 10px',
          font: 'var(--typo-display-extra-large-font)',
          letterSpacing: 'var(--typo-display-extra-large-tracking)',
        }}
      >
        <span className='mb-3 last:mb-0' style={{ whiteSpace: 'pre-wrap', textAlign: 'start' }}>
          Piercing Owl Stare
        </span>
      </div>
    </section>
  )
}
